import { Base64 } from 'js-base64';

import { IOpenApiInfo } from 'APIPackage/MainModule/interfaces/IOpenApiInfo';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { apiGetWithAuth } from 'APIPackage/MainModule/common/apiTools';

import { IKnmPreviewResponse } from '../interfaces/IKnmPreviewResponse';
import { IKnmSearchFilter } from '../interfaces/IKnmSearchFilter';
import { IKnmSearchResponse } from '../interfaces/IKnmSearchResponse';

export async function searchKNM(
  openApiInfo: IOpenApiInfo,
  page: number,
  size: number,
  filter: IKnmSearchFilter,
  order?: string,
): Promise<IKnmSearchResponse> {
  const params = new URLSearchParams();

  params.append('page', `${String(size)},${String(page)}`);
  Object.keys(filter).forEach((item: keyof IKnmSearchFilter) => {
    const value = filter[item];

    if (value) {
      if (typeof value === 'string') {
        params.set(item, value);
      } else {
        value.forEach(v => params.append(item, v));
      }
    }
  });
  if (order) {
    params.append('order', order);
  }

  return apiGetWithAuth<IKnmSearchResponse>({
    url: `${openApiInfo.url}/inspections/find?${params}`,
    isCredentials: false,
    authorization: `Basic ${Base64.encode(`${openApiInfo.username}:${openApiInfo.password}`)}`,
  });
}

export async function exportKnm(
  openApiInfo: IOpenApiInfo,
  filter: IKnmSearchFilter,
  format: ExportFormatsEnum,
): Promise<Blob> {
  const params = new URLSearchParams();

  Object.keys(filter).forEach((item: keyof IKnmSearchFilter) => {
    const value = filter[item];

    if (typeof value === 'string') {
      params.set(item, value);
    } else {
      value.forEach(v => params.append(item, v));
    }
  });

  return apiGetWithAuth<Blob>({
    url: `${openApiInfo.url}/inspections/${format.toLowerCase()}-list?${params}`,
    isCredentials: false,
    authorization: `Basic ${Base64.encode(`${openApiInfo.username}:${openApiInfo.password}`)}`,
  });
}

export async function fetchPassportById(openApiInfo: IOpenApiInfo, id: string): Promise<IKnmPreviewResponse> {
  return apiGetWithAuth<IKnmPreviewResponse>({
    url: `${openApiInfo.url}/inspections/${id}`,
    isCredentials: false,
    authorization: `Basic ${Base64.encode(`${openApiInfo.username}:${openApiInfo.password}`)}`,
  });
}

export async function fetchPassportPdfById(openApiInfo: IOpenApiInfo, id: string): Promise<Blob> {
  return apiGetWithAuth<Blob>({
    url: `${openApiInfo.url}/inspections/${id}/pdf`,
    isCredentials: false,
    authorization: `Basic ${Base64.encode(`${openApiInfo.username}:${openApiInfo.password}`)}`,
  });
}
